import { DashboardShell } from "@/components/dashboard-shell";
import { ContactsTable } from "@/components/contacts/contacts-table";
import { createFileRoute } from "@tanstack/react-router";
import {
  RouteLoading,
  ToolbarSkeleton,
  TableSkeleton,
} from "@/components/route-loading";

export const Route = createFileRoute("/contacts")({
  component: ContactsPage,
  head: () => ({ meta: [{ title: "Contacts" }] }),
  pendingComponent: ContactsPending,
});

function ContactsPage() {
  return (
    <DashboardShell>
      <ContactsTable />
    </DashboardShell>
  );
}

// Shown while this route's chunk (and the ReUI components in it)
// downloads. Was src/app/contacts/loading.tsx.
function ContactsPending() {
  return (
    <RouteLoading>
      <ToolbarSkeleton />
      <TableSkeleton />
    </RouteLoading>
  );
}
